import { StyleSheet, View } from 'react-native';
import { Button } from '../crop-circle/Button';

export type PillToggleOption = {
  value: any;
  label: string;
};

export type PillToggleProps = {
  options: PillToggleOption[];
  value: any;
  setValue: (value: any) => void;
  disabled?: boolean;
};

export const PillToggle = (props: PillToggleProps) => {
  const onPress = (option: PillToggleOption) => {
    const selected = props.options.filter((o) => o === option)[0];
    props.setValue(selected.value);
  };

  return (
    <View style={stylesCropCircle.container}>
      {props.options.map((option) => (
        <Button
          key={option.value}
          state={props.value === option.value ? 'active' : 'default'}
          onPress={() => onPress(option)}
          disabled={props.disabled}
          variant="rectangular"
          size="large"
          style={stylesCropCircle.option}
        >
          {option.label}
        </Button>
      ))}
    </View>
  );
};

const stylesCropCircle = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
    gap: 8,
  },
  option: {
    flex: 1,
  },
});
